import type { DeployCommandLine } from "@/pages/DeploymentsPage/helpers/deployment-command.types"
import type { AgentPlatformStepOption } from "./AgentPlatformTab.types"

// The Python tool guard is off unless the user opts in: entries of the
// deploy's environment variables object (jq), in observe mode
export const GUARD_LINES = {
  variablesGuard: { text: 'KODEM_AI_POLICIES_ENABLED: "true",' },
  variablesGuardMode: { text: 'KODEM_AI_POLICIES_MODE: "observe",' }
} satisfies Record<string, DeployCommandLine>

// The agentless method's key, in each platform's tab
export const CLOUD_CONNECTION_METHOD = "cloudConnection"

export const GUARD_OPTION: AgentPlatformStepOption = {
  label: "agentPlatform.guardOption",
  description: "agentPlatform.guardOptionDescription",
  lines: Object.keys(GUARD_LINES),
  optIn: true
}
